/**
 * Eski panel formlarından gelen alan adlarını API modeline çevirir.
 * (Önbellekte kalan eski JS veya manuel alan adları için.)
 */

function toIsoDatetime(value) {
    if (!value) return null;
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return null;
    return d.toISOString();
}

export function normalizeRandevuPayload(raw = {}) {
    const baslik = (raw.baslik ?? raw.konu ?? "").trim();
    const baslangic = raw.baslangic ?? raw.tarih;
    let bitis = raw.bitis;

    if (!bitis && baslangic && raw.sure_dakika != null && raw.sure_dakika !== "") {
        const start = new Date(baslangic);
        if (!Number.isNaN(start.getTime())) {
            start.setMinutes(start.getMinutes() + (Number(raw.sure_dakika) || 0));
            bitis = start.toISOString();
        }
    }
    if (!bitis && baslangic) {
        const start = new Date(baslangic);
        if (!Number.isNaN(start.getTime())) {
            start.setHours(start.getHours() + 1);
            bitis = start.toISOString();
        }
    }

    const payload = {
        baslik,
        baslangic: toIsoDatetime(baslangic),
        bitis: toIsoDatetime(bitis),
        muvekkil: raw.muvekkil || null,
        sigorta_dosyasi: raw.sigorta_dosyasi || null,
        tip: raw.tip || "gorusme",
        onem: raw.onem || "orta",
        durum: raw.durum || "planlandi",
        konum: (raw.konum ?? raw.yer ?? "").trim(),
        tum_gun: Boolean(raw.tum_gun),
        aciklama: (raw.aciklama ?? raw.notlar ?? "").trim(),
    };
    if (raw.varsayilan_hatirlatma_dk != null && raw.varsayilan_hatirlatma_dk !== "") {
        payload.varsayilan_hatirlatma_dk = Number(raw.varsayilan_hatirlatma_dk) || 0;
    }
    return payload;
}

const KANAL_LEGACY = {
    yuzyuze: "yuz_yuze",
    yuz_yuze: "yuz_yuze",
    telefon: "telefon",
    video: "online",
    online: "online",
    email: "eposta",
    eposta: "eposta",
    whatsapp: "whatsapp",
};

export function normalizeGorusmeNotuPayload(raw = {}) {
    const kanalRaw = raw.kanal ?? raw.gorusme_yontemi;
    return {
        konu: (raw.konu ?? raw.baslik ?? "").trim(),
        muvekkil: raw.muvekkil || null,
        sigorta_dosyasi: raw.sigorta_dosyasi || null,
        gorusme_zamani: toIsoDatetime(raw.gorusme_zamani ?? raw.tarih) || new Date().toISOString(),
        kanal: KANAL_LEGACY[kanalRaw] || kanalRaw || "yuz_yuze",
        ozet: (raw.ozet ?? raw.notlar ?? "").trim(),
        detay: (raw.detay ?? "").trim(),
        sonraki_aksiyon: (raw.sonraki_aksiyon ?? "").trim(),
        sonraki_aksiyon_tarihi: toIsoDatetime(raw.sonraki_aksiyon_tarihi),
    };
}

export function normalizeHatirlatmaPayload(raw = {}) {
    return {
        baslik: (raw.baslik ?? "").trim(),
        aciklama: (raw.aciklama ?? "").trim(),
        hatirlatma_zamani: toIsoDatetime(raw.hatirlatma_zamani ?? raw.tarih),
        ofset_dk: raw.ofset_dk != null && raw.ofset_dk !== "" ? Number(raw.ofset_dk) : 0,
        yontem: raw.yontem || "sistem",
        gonderildi_mi: Boolean(raw.gonderildi_mi ?? raw.tamamlandi),
    };
}

export function normalizeEntityPayload(entityKey, raw) {
    if (entityKey === "randevular") return normalizeRandevuPayload(raw);
    if (entityKey === "gorusme-notlari") return normalizeGorusmeNotuPayload(raw);
    if (entityKey === "hatirlatmalar") return normalizeHatirlatmaPayload(raw);
    if (entityKey === "muvekkiller" && raw && "aracilar" in raw) {
        const ids = raw.aracilar;
        const arr = Array.isArray(ids) ? ids : ids == null ? [] : [ids];
        return {
            ...raw,
            aracilar: arr
                .map((x) =>
                    typeof x === "object" && x != null ? x.id ?? x : x,
                )
                .filter((x) => x != null && x !== "")
                .map((x) => Number(x))
                .filter((x) => !Number.isNaN(x)),
        };
    }
    return raw;
}
